import React from 'react'
import {
    IconButton,
    Tooltip,
    TableRow,
    TableCell,
    Collapse,
    Box,
    Table,
    TableHead,
    TableBody,
    makeStyles,
    createStyles,
    useTheme
} from '@material-ui/core';
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import DeleteIcon from "@material-ui/icons/Delete";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile"
import copy from 'copy-to-clipboard';
import {Theme} from "@material-ui/core/styles"
import {DigResult, MxResult, SoaResult, SrvResult} from "../App";


const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    tableCellStyles: {
        color: 'black'
    },
    errorIconButton: {
        color: theme.palette.error.main,
        marginRight: '20px'
    },
    noResults: {
        display: 'flex',
        alignItems: 'center',
        background: theme.palette.error.main,
        height: "30px",
        width: '100%',
        margin: '10px',
        padding: '20px',
        borderRadius: '5px',
        color: theme.palette.secondary.main
    }
}));

function NoResults() {
    const classes = useStyles();
    return (
        <div className={classes.noResults}>
            <ErrorOutlineIcon style={{ marginRight: '10px'}} color='secondary' />
            <h5>There were no records returned for this lookup</h5>
        </div>
    )
}

export interface RowProps {
    row: any,
    deleteRow: any,
    index: number,
    rowOpen?: boolean
}

export default function Row(props: RowProps) {
    const {row, deleteRow, index, rowOpen = false} = props;
    const [open, setOpen] = React.useState(rowOpen)
    const classes = useStyles();

    // NOTE: DO NOT change the formatting on this string
    function copyRowResults() {
        const answer = (type: string) => {
            if (type === "MX") {
                return row.result
                    .map((obj: {priority: number, value: string}) => {
                        return `Priority: ${obj.priority}, Value: ${obj.value}\n`;
                    })
                    .join(' ')
            } else if (type === "SOA") {

                return row.result
                    .map((obj: {serial: number, expire: number, refresh: number, retry: number}) => {
                        return `Serial: ${obj.serial} \nExpire: ${obj.expire} \nRefresh: ${obj.refresh} \nRetry: ${obj.retry}`
                    })
                    .join(' ')
            } else if (type === "SRV") {
                return row.result
                    .map((obj: {port: number, priority: number, weight: number, target: string}) => {
                        return `Port: ${obj.port}, Priority: ${obj.priority}, Weight: ${obj.weight}, Target: ${obj.target}`
                    })
                    .join(' ')
            } else {
                return row.result
                    .map((ip: DigResult) => {
                        return `${ip.answer}\n`;
                    })
                    .join(' ')
            }
        }
        // const response = `Dig Results for ${row.host} from ${row.location} \nName Server used: ${row.nameServer} \nRecord Type Queried: ${row.recordtype} \nResponse Time: ${row.responsetime}ms \n\nAnswer: \n${answer(row.recordtype)} \n\nHere is the link to run this query in real time: \nhttps://www.constellix.com/dnslookup?domain=${row.host}&type=${row.recordtype}&resolver=${row.nameServer}&location=${row.location.toLowerCase()}01-mon01.nodes.constellix.net \n\nFor more assistance in identifying and troubleshooting your DNS record please use the tools at https://www.dnstoolbox.io`
        const response = `Dig Results for ${row.host} from ${row.location} \nName Server used: ${row.nameServer} \nRecord Type Queried: ${row.recordtype} \nResponse Time: ${row.responsetime}ms \n\nTTL: ${row.result[0].ttl}ms \n\nAnswer: \n${answer(row.recordtype)} \n\nFor more assistance in identifying and troubleshooting your DNS record please use the tools at https://www.dnstoolbox.io`
        copy(response)
    }


    if (row.recordtype === "SRV") {
        return (
            <React.Fragment>
                <TableRow className={classes.root}>
                    <TableCell>
                        <div style={{display: 'flex'}}>
                            <div style={{}}>
                                <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                                    {open ? <KeyboardArrowUpIcon color='primary'/> :
                                        <KeyboardArrowDownIcon color='primary'/>}
                                </IconButton>
                            </div>
                            <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                                <div style={{width: '20%', textAlign: 'center', fontWeight: 'bold'}}>{row.host}</div>
                                <div style={{
                                    width: '20%',
                                    textAlign: 'center',
                                    paddingRight: '10px'
                                }}>{row.location}</div>
                                <div style={{
                                    width: '20%',
                                    textAlign: 'center',
                                    paddingRight: '5px'
                                }}>{row.nameServer}</div>
                                <div style={{width: '20%', textAlign: 'center', paddingLeft: '50px'}}>{row.responsetime}ms
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    width: '15%',
                                    textAlign: 'center'
                                }}>
                                    <Tooltip title={'Delete Row'}>
                                        <IconButton onClick={() => deleteRow(row.checkedat)}
                                                    className={classes.errorIconButton}
                                                    size='small'><DeleteIcon/></IconButton>
                                    </Tooltip>
                                    <Tooltip title={'Copy results from row'}>
                                        <IconButton color='primary' size='small'
                                                    onClick={copyRowResults}><InsertDriveFileIcon/></IconButton>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                        <Collapse timeout={70} in={open} unmountOnExit>
                            <Box margin={0}>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align='center'>Type</TableCell>
                                            <TableCell align='center'>Port</TableCell>
                                            <TableCell align='center'>Priority</TableCell>
                                            <TableCell align='center'>Weight</TableCell>
                                            <TableCell align='center'>Target</TableCell>
                                            <TableCell align='center'>TTL</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row.result.length > 0 ? row.result.map((result: any) => (
                                            <TableRow key={result.value}>
                                                <TableCell align='center'>
                                                    {row.recordtype}
                                                </TableCell>
                                                <TableCell align='center'>{result.port}</TableCell>
                                                <TableCell align='center'>{result.priority}</TableCell>
                                                <TableCell align='center'>{result.weight}</TableCell>
                                                <TableCell align='center'>{result.target}</TableCell>
                                                <TableCell align='center'>{result.ttl}</TableCell>
                                            </TableRow>
                                        )) : <NoResults/>}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    if (row.recordtype === "SOA") {
        console.log("SOA", row)
        return (
            <React.Fragment>
                <TableRow className={classes.root}>
                    <TableCell>
                        <div style={{display: 'flex'}}>
                            <div style={{}}>
                                <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                                    {open ? <KeyboardArrowUpIcon color='primary'/> :
                                        <KeyboardArrowDownIcon color='primary'/>}
                                </IconButton>
                            </div>
                            <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                                <div style={{width: '20%', textAlign: 'center', fontWeight: 'bold'}}>{row.host}</div>
                                <div style={{
                                    width: '20%',
                                    textAlign: 'center',
                                    paddingRight: '10px'
                                }}>{row.location}</div>
                                <div style={{
                                    width: '20%',
                                    textAlign: 'center',
                                    paddingRight: '5px'
                                }}>{row.nameServer}</div>
                                <div style={{width: '20%', textAlign: 'center', paddingLeft: '50px'}}>{row.responsetime}ms
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    width: '15%',
                                    textAlign: 'center'
                                }}>
                                    <Tooltip title={'Delete Row'}>
                                        <IconButton onClick={() => deleteRow(row.checkedat)}
                                                    style={{color: 'red', marginRight: '20px'}}
                                                    size='small'><DeleteIcon/></IconButton>
                                    </Tooltip>
                                    <Tooltip title={'Copy results from row'}>
                                        <IconButton color='primary' size='small'
                                                    onClick={copyRowResults}><InsertDriveFileIcon/></IconButton>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                        <Collapse timeout={70} in={open} unmountOnExit>
                            <Box margin={0}>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align='center'>Type</TableCell>
                                            <TableCell align='center'>Serial</TableCell>
                                            <TableCell align='center'>Expire</TableCell>
                                            <TableCell align='center'>Refresh</TableCell>
                                            <TableCell align='center'>Retry</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row.result.length > 0 ? row.result.map((result: any) => (
                                            <TableRow key={result.value}>
                                                <TableCell align='center'>
                                                    {row.recordtype}
                                                </TableCell>
                                                <TableCell align='center'>{result.serial}</TableCell>
                                                <TableCell align='center'>{result.expire}</TableCell>
                                                <TableCell align='center'>{result.refresh}</TableCell>
                                                <TableCell align='center'>{result.retry}</TableCell>
                                            </TableRow>
                                        )) : <NoResults/>}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    if (row.recordtype === "MX") {

        return (
            <React.Fragment>
                <TableRow className={classes.root}>
                    <TableCell>
                        <div style={{display: 'flex'}}>
                            <div style={{}}>
                                <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                                    {open ? <KeyboardArrowUpIcon color='primary'/> :
                                        <KeyboardArrowDownIcon color='primary'/>}
                                </IconButton>
                            </div>
                            <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                                <div style={{width: '20%', textAlign: 'center', fontWeight: 'bold'}}>{row.host}</div>
                                <div style={{
                                    width: '20%',
                                    textAlign: 'center',
                                    paddingRight: '10px'
                                }}>{row.location}</div>
                                <div style={{
                                    width: '20%',
                                    textAlign: 'center',
                                    paddingRight: '5px'
                                }}>{row.nameServer}</div>
                                <div style={{width: '20%', textAlign: 'center', paddingLeft: '50px'}}>{row.responsetime}ms
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    width: '15%',
                                    textAlign: 'center'
                                }}>
                                    <Tooltip title={'Delete Row'}>
                                        <IconButton onClick={() => deleteRow(row.checkedat)}
                                                    style={{color: 'red', marginRight: '20px'}}
                                                    size='small'><DeleteIcon/></IconButton>
                                    </Tooltip>
                                    <Tooltip title={'Copy results from row'}>
                                        <IconButton color='primary' size='small'
                                                    onClick={copyRowResults}><InsertDriveFileIcon/></IconButton>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                        <Collapse timeout={70} in={open} unmountOnExit>
                            <Box margin={0}>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align='center'>Type</TableCell>
                                            <TableCell align='center'>Priority</TableCell>
                                            <TableCell align='center'>Value</TableCell>
                                            <TableCell align='center'>TTL</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row.result.length > 0 ? row.result.map((result: any) => (
                                            <TableRow key={result.value}>
                                                <TableCell align='center'>
                                                    {row.recordtype}
                                                </TableCell>
                                                <TableCell align='center'>{result.priority}</TableCell>
                                                <TableCell align='center'>{result.value}</TableCell>
                                                <TableCell align='center'>{result.ttl}</TableCell>
                                            </TableRow>
                                        )) : <NoResults/>}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <TableRow className={classes.root}>
                <TableCell>
                    <div style={{display: 'flex'}}>
                        <div style={{}}>
                            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                                {open ? <KeyboardArrowUpIcon color='primary'/> :
                                    <KeyboardArrowDownIcon color='primary'/>}
                            </IconButton>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                            <div style={{width: '20%', textAlign: 'center', fontWeight: 'bold'}}>{row.host}</div>
                            <div style={{width: '20%', textAlign: 'center', paddingRight: '10px'}}>{row.location}</div>
                            <div style={{width: '20%', textAlign: 'center', paddingRight: '5px'}}>{row.nameServer}</div>
                            <div style={{width: '20%', textAlign: 'center', paddingLeft: '50px'}}>{row.responsetime}ms
                            </div>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                width: '15%',
                                textAlign: 'center'
                            }}>
                                <Tooltip title={'Delete Row'}>
                                    <IconButton onClick={() => deleteRow(row.checkedat)}
                                                style={{color: 'red', marginRight: '20px'}}
                                                size='small'><DeleteIcon/></IconButton>
                                </Tooltip>
                                <Tooltip title={'Copy results from row'}>
                                    <IconButton color='primary' size='small'
                                                onClick={copyRowResults}><InsertDriveFileIcon/></IconButton>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                    <Collapse timeout={70} in={open} unmountOnExit>
                        <Box margin={0}>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='center'>Type</TableCell>
                                        <TableCell align='center'>Host</TableCell>
                                        <TableCell align='center'>TTL</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.result.length > 0 ? row.result.map((result: any, index: any) => (
                                        <TableRow key={index}>
                                            <TableCell align='center'>
                                                {row.recordtype}
                                            </TableCell>
                                            <TableCell align='center'>{result.answer}</TableCell>
                                            <TableCell align='center'>{result.ttl}</TableCell>
                                        </TableRow>
                                    )) : <NoResults/>}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}